export default "__VITE_ASSET__D05xmd7i__"